<template>
	<div class="main-screen-settings">
		<div class="top top-minus-margin">
			<img src="/build/icons/settings-arrowback.svg" @click="viewSlide('main-settings-page')" class="back-arrow">
			<h1>{{ $t('subscription.title') }}</h1>
		</div>
		<div class="subscription-box">
			<div class="top-section">
				<p class="first">
					{{ $auth.user().package.name }}
					<span>{{ $auth.user().package.short_description }}</span>
				</p>
				<p class="second">
					{{ newPrices.find((el) => el.package_id == $auth.user().package.id) ? newPrices.find((el) => el.package_id == $auth.user().package.id).price + ' ' + $auth.user().package.euro_prefix : $auth.user().package.price_in_euro + ' ' + $auth.user().package.euro_prefix }}
					<span>{{ $t('subscription.monthly') }}</span>
				</p>
			</div>
			<div class="second-section" v-bind:class="{has_button: $auth.user().package.can_upgrade_account}">
				<div class="boxes-left">
					<div class="box">
						{{ $auth.user().package.user_limit == 0 ? '&infin;' : $auth.user().package.user_limit}} 
						<span>{{ $t('subscription.employees') }}</span>
					</div>
					<!-- <div class="box">
						{{ $auth.user().package.objective_limit }} 
						<span>obiective</span>
					</div> -->
					<div class="box second">
						{{ $auth.user().package.objective_limit == 0 ? '&infin;' : $auth.user().package.objective_limit}} 
						<span>{{ $t('subscription.objectives') }}</span>
					</div>
					<div class="box button">
						<button :class="[$auth.user().package.can_upgrade_account ? 'btn-blue-tbf' : 'btn-default-tbf']" @click="viewSlide('upgrade_subscription')">{{ $auth.user().package.can_upgrade_account ? $t('subscription.change') : $t('subscription.change-to-low') }}</button>
					</div>
				</div>	
			</div>
		</div>

		<div class="short-description-modal" v-if="$auth.user().status == 'grace_period'">{{ $t('subscription.grace_period_desc') }}</div>

		<div class="form-section" v-if="loaded">
			<div class="input-group-tbf first" v-bind:class="{has_error: $auth.user().status == 'grace_period'}">
				<div class="label-input">
					<label>{{ $t('subscription.card-details') }}</label>
					<div class="error-msg" v-if="$auth.user().status == 'grace_period'">{{ $t('subscription.error_payment') }}</div>
				</div>
				<div class="input-box input-custom-box input-custom-box-bill">
					<credit-card-icon class="icon-left"/>
					<span>**** **** **** {{ cardDetails.last4 }}<i>{{ cardDetails.exp_month }}/{{ cardDetails.exp_year }}</i></span>
					<button class="edit-property" @click="viewSlide('card_details')"><icon-pencil /></button>
				</div>
			</div>
		</div>
		<div class="form-section" v-else>
			<div class="input-group-tbf">
				<div class="label-input">
					<label><div class="placeholder-loader" style="height: 21px; width: 130px;"></div></label>
				</div>
				<div class="input-box placeholder-loader" style="height: 40px;"></div>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import IconInfo from "../Icons/Info"
	import CreditCardIcon from "../Icons/CreditCard"
	import IconPlus from "../Icons/Plus"
	import IconPencil from "../Icons/PencilAvatar"

	export default {
		data() {
			return {
				loaded: false,
				cardDetails: {},
				activeTooltip: '',
				newPrices: []
			};
		},
		components: {
			IconInfo,
			CreditCardIcon,
			IconPlus,
			IconPencil
		},
		async mounted() {
			this.getUserNewPrices();
			await this.getCardDetails()
		},
		methods: {
			async getCardDetails(){
				await axios.get('card-details')
				.then(({data}) => {
					this.cardDetails = data
				}).then(() => {
					this.loaded = true
				})
			},
			getUserNewPrices(){
				axios.post('get-referral-coupon', {instance_id : this.$auth.user().instance_id}).then((data) => {
					if(data.data.is_valid){
						this.newPrices = data.data.values;
					}
				})				
			},
			viewSlide(slide){
				this.$emit('change_slide', slide)
			}
		}
	};
</script>